
import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom";
import SendData from "./SendData"
import socket from './../socket.js'

//import GetCode from "./GetCode";

function MainSetting (){
  const [phone,setPhone] = useState ("");
  const navigate = useNavigate ();
  useEffect (()=>{
    if (!socket)return;
    socket.on ('message',(data)=>{


          if (JSON.parse(data).event=="phone_undefined")window.alert('شماره وارد شده نا معتبر می باشد')
          if (JSON.parse(data).event=="code_send")
          {
            navigate ("/GetCode",{state:{phone:JSON.parse(data).data.phone}});
          }
      });
//    socket.on ('message',(data)=>{
//      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
//      if (data.event==='code_send') window.alert(data.data);
//    });
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
      <div style={style.content}>
      <button className="btn"
        onClick ={()=>{
          navigate ('/SystemSetting');
        }}>
         تنظیمات سیستم
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="TIMES")navigate ("/TimeSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_times"});

        }}>
          تنظیمات بر حسب زمان
      </button>
    </div>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default MainSetting;
